














import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ClaioSchemaItem } from "../../../../../../domain/claio";
import { IImageDragParameter } from "../../../../../dragging";

@Component({
  components: {
  }
})
export default class ClaioSchemaThumbnail extends Mixins() {
  data(): any {
    return {
      imageWidthText: null,
      imageHeightText: null,
    };
  }
  imageWidthText: string;
  imageHeightText: string;
  
  @Prop()
  item: ClaioSchemaItem;

  @Prop()
  isFocused: boolean;

  get imageSource(): string {
    return this.item.imageSource.thumbnailSource;
  }

  get rootStyle(): any {
    return {
      outline: this.isFocused ? "2px solid rgba(255, 0, 0, 0.5)" : "none",
    };
  }

  adjustImageSize(): void {
    const image = this.$refs.image as HTMLImageElement;
    if (!image) { return; }
    this.imageWidthText = (image.naturalWidth >= image.naturalHeight) ? "100%" : null;
    this.imageHeightText = (image.naturalWidth <= image.naturalHeight) ? "100%" : null;
  }

  onDragStart(event: DragEvent): void {
    const data: IImageDragParameter = {
      isClaioSchema: true,
      claioSchemaDragParameter: {
        schemaTemplateId: this.item.templateId,
        schemaGroupId: this.item.groupId,
        schemaItemId: this.item.itemId,
      }
    };
    const text = JSON.stringify(data);
    // 第一引数(format)が"text"でないとIEでエラーになる。
    event.dataTransfer.setData("text", text);
  }

  onThumbnailSelected(event: PointerEvent): void {
    this.selected(this.item);
  }

  @Emit()
  selected(src: ClaioSchemaItem): void {}
}
